import { InvoiceType } from '../../invoice/invoices/invoices.enums';

export const invoiceTypeNotification = {
  [InvoiceType.NFE]: 'NFe',
  [InvoiceType.NFC]: 'NFCe',
  [InvoiceType.NFS]: 'NFSe',
  [InvoiceType.CFE]: 'CFe',
};

export const invoiceTypeUrl = {
  [InvoiceType.NFE]: 'nfe',
  [InvoiceType.NFC]: 'nfc',
  [InvoiceType.NFS]: 'nfs',
  [InvoiceType.CFE]: 'cfe',
};

export interface CancelInvoiceRequest {
  invoiceId: number;
  justification: string;
  type: InvoiceType;
}

export interface InvoiceMailRequest {
  email: string;
  invoiceId: number;
  type: InvoiceType;
}

export interface InvoiceTransmitRequest {
  invoiceId: number;
  newNumber?: number;
  type: InvoiceType;
}

export interface InvoiceConsultRequest {
  duplicateKey?: string;
  invoiceId: number;
  type: InvoiceType;
}

export interface InvoiceMirrorRequest {
  invoiceId: number;
  type: InvoiceType;
}

export interface InvoiceFileRequest {
  invoiceId: number;
  type: InvoiceType;
}
